export default __webpack_public_path__ + "static/premio-pe-3d721b929fc719f742d2995a3b02062c.png";